import Cookies from 'js-cookie'

/**
 * @description
 *
 * Функция достает из кук CSRF токен и возвращает его
 *
 * @returns {string} - CSRF токен или пустая строка, если его не удастся получить
 */

function getCSRFToken() {
  try {
    return Cookies.get('csrftoken') || ''
  } catch {
    return ''
  }
}

export default getCSRFToken
